import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExpand} from "@fortawesome/free-solid-svg-icons";

const FullScreenIcon = props => {
  const {onToggleFullscreen} = props;

  return (
    <FontAwesomeIcon
      icon={faExpand}
      className={'icon-fullscreen'}
      onClick={onToggleFullscreen}
    />
  );
};

export default FullScreenIcon;
